import appStore from './modules/app-store.js';
import auth from '@/auth';
import authStore from './modules/auth-store.js';
import axios from 'axios';
import { cloneDeep } from 'lodash';
import contracts from './modules/contracts-store.js';
import createErrorreportStore from './modules/create-errorreport-store.js';
import { createStore } from 'vuex';
import dashboard from './modules/dashboard-store.js';
import errorreports from './modules/errorreport-store.js';
import geoLocationStore from './modules/geolocation-store.js';
import oncallStore from './modules/oncall-store.js';
import infoscreens from './modules/infoscreen-store.js';
import invoices from './modules/invoices-store.js';
import issues from './modules/issues-store.js';
import laundry from './modules/laundry-store.js';
import measures from './modules/measures-store.js';
import noteofinterests from './modules/noteofinterests-store.js';
import objectsStore from './modules/objects-store.js';
import offers from './modules/offers-store.js';
import pingStore from './modules/ping-store.js';
import profile from './modules/profile-store.js';
import rentCntractsStore from './modules/rentcontracts-store.js';
import subscriptions from './modules/subscriptions-store.js';
import vacancy from './modules/vacancy-store.js';
import vuexCache from 'vuex-cache';
import webappconfig from './modules/webappconfig-store.js';

/**
 * Reset the store to its initial state.
 */
const resetStore = (store) => {
  const initState = cloneDeep(store.state);

  store.resetStore = () => {
    const newState = cloneDeep(initState);

    /**
     * Preserve current `authStore` state if auth token might have changed.
     */
    newState.authStore = store.state.authStore;

    store.replaceState(newState);
  };
};

/**
 * Initialize store with axios interceptors.
 */
const initStore = (store) => {
  axios.interceptors.response.use(
    // If response is OK
    (response) => {
      if (response.status >= 200 && response.status < 300) {
        auth.refreshTokenCookie();
      }
      return response;
    },
    // If response has errors
    (error) => {
      if (error.response) {
        // Handle response errors here
      }
      return Promise.reject(error);
    }
  );
};

// Create Vuex store
const store = createStore({
  plugins: [
    vuexCache({ timeout: 10000 }),
    (store) => resetStore(store),
    (store) => initStore(store),
  ],
  modules: {
    authStore,
    profile,
    dashboard,
    subscriptions,
    measures,
    laundry,
    contracts,
    invoices,
    errorreports,
    issues,
    offers,
    vacancy,
    noteofinterests,
    infoscreens,
    webappconfig,
    appStore,
    rentCntractsStore,
    objectsStore,
    pingStore,
    createErrorreportStore,
    geoLocationStore,
    oncallStore,
  },
});

export default store;
